import theme from 'shared/styles/theme';

const toCamelCase = (str: string) => {
  return str
    .toLowerCase()
    .replace(/_([a-z])/g, (_, char: string) => char?.toUpperCase());
};

const getVXLColor = (color: string) => {
  const parts = color.split('_');
  let folderName = toCamelCase(parts.shift() ?? '');

  if (!parts.length || !folderName) {
    throw new Error('Input string must contain at least one underscore.');
  }

  let colorGroup: { [key: string]: string } | undefined;

  while (!colorGroup && parts.length) {
    colorGroup = theme.color[toCamelCase(folderName)] as
      | { [key: string]: string }
      | undefined;

    if (!colorGroup) {
      folderName = folderName + '_' + parts.shift();
    }
  }

  const colorName = toCamelCase(parts.join('_'));

  if (!colorGroup) {
    throw new Error(`Color group "${folderName}" not found in theme.`);
  }

  const updatedColor = colorGroup[colorName];
  if (!updatedColor) {
    throw new Error(
      `Color "${colorName}" not found in "${folderName}" color group.`,
    );
  }

  return updatedColor;
};

export { getVXLColor };
